import { ArrowForwardIcon } from '@chakra-ui/icons'
import { Box, Flex, IconButton, Stack, Text } from '@chakra-ui/react'
import {
  BoxHeader,
  BoxSubheader2,
  FloatingContainer,
  FormPreview,
  InlineLink,
  useFormsView,
} from '@hb/react-web'
import { AssessmentFormKey, colors } from '@hb/shared'
import React, { useMemo } from 'react'

import { useAppModals } from '@hb/react'
import { useAssessmentForm } from '@hb/react-web'
import {
  insurancePlansFaq,
  marketplacePlansFaq,
  medicaidPlansFaq,
} from '../Resources/insurancePlansFaq'
import { FAQListView } from '../Resources/ResourcesView'
import { AnythingElseNote } from './AnythingElseNote'

const PlanOptionsView = () => (
  <>
    <BoxHeader style={{ marginBottom: '0.5rem' }}>Information on insurance plans</BoxHeader>
    <Stack>
      <FAQListView size="sm" {...insurancePlansFaq} />
      <FAQListView size="sm" {...marketplacePlansFaq} />
      <FAQListView size="sm" {...medicaidPlansFaq} />
    </Stack>
  </>
)
const PlanOptionsPanel = () => (
  <Box px={[0, 2]}>
    <FloatingContainer py={[4, 6]} px={[4, 6]} pb={0}>
      <PlanOptionsView />
    </FloatingContainer>
  </Box>
)

const NotPregnantView = () => (
  <Box>
    <Text>
      Thank you for your interest in Hamilton Billing! We will be in touch with a preliminary
      assessment of your coverage
    </Text>
  </Box>
)

const NoCoveragePanel = () => (
  <Box px={[0, 2]}>
    <FloatingContainer py={[4, 6]} px={[4, 6]} pb={0}>
      <PlanOptionsView />
    </FloatingContainer>
  </Box>
)

const NotPregnantPanel = () => (
  <Box px={[0, 2]}>
    <FloatingContainer py={[4, 6]} px={[4, 6]} pb={0}>
      <NotPregnantView />
      <PlanOptionsView />
    </FloatingContainer>
  </Box>
)

const ScheduleCallPanel = () => {
  const { scheduleCall } = useAppModals()
  return (
    <FloatingContainer>
      <BoxHeader>Schedule a call</BoxHeader>
      <Flex>
        Follow this link to{' '}
        <InlineLink
          onClick={() => {
            scheduleCall.open('FormsView')
          }}>
          schedule a call with us
        </InlineLink>
      </Flex>
    </FloatingContainer>
  )
}

export const AssessmentFormPreview: React.FC<{
  formId: AssessmentFormKey
  first?: boolean
  assessmentIndex: number | null
}> = ({ formId, first }) => {
  const {
    open,
    formData,
    assessment: { assessmentData, populated },
  } = useFormsView()

  const { status, form } = useAssessmentForm(false, populated, formId)
  const stageKeys = useMemo(() => Object.keys(form?.stages ?? {}), [form])
  if (formId === 'not-pregnant') return <NotPregnantPanel />
  if (formId === 'no-coverage') return <NoCoveragePanel />
  if (formId === 'plan-options') return <PlanOptionsPanel />
  if (formId === 'schedule-call') return <ScheduleCallPanel />
  return (
    <Flex w="100%" px={[0, 2]} py={1}>
      <FloatingContainer
        style={{
          borderTop: first ? undefined : '1px solid #cdcdcd',
          height: 'auto',
          minHeight: 40,
          cursor: status === 'incomplete' ? 'pointer' : 'default',
        }}>
        <Flex
          w="100%"
          transition="opacity 500ms"
          align="flex-start"
          justify="flex-start"
          flexFlow="column">
          <Flex gap={2} align="center" width="100%">
            <BoxHeader cursor="pointer">{form?.name ?? ''}</BoxHeader>
            {status === 'incomplete' ? (
              <IconButton
                ml="auto"
                onClick={() => {
                  open(formId, stageKeys[0])
                }}
                aria-label="begin form"
                borderRadius="full"
                background={colors.green.hex}
                height={8}
                minW={8}
                color={'white'}
                icon={<ArrowForwardIcon width={5} height={5} />}
                size="sm"
              />
            ) : null}
          </Flex>
          {form?.description ? <BoxSubheader2 mb={2}>{form.description}</BoxSubheader2> : null}
          {/* <Collapse style={{ width: '100%' }} in={status !== 'incomplete'}> */}
          {form ? (
            <FormPreview
              form={form}
              corrections={formData.corrections ?? {}}
              data={formData ?? {}}
              readOnly={!!assessmentData?.submittedOn}
              onStageEdit={stageId => {
                open(formId, stageId)
              }}>
              {formId === 'introduction' ? <AnythingElseNote /> : null}
            </FormPreview>
          ) : (
            <Text style={{ color: 'orangered' }}>{`Error: Can't find form with id ${formId}`}</Text>
          )}
          {/* </Collapse> */}
        </Flex>
      </FloatingContainer>
    </Flex>
  )
}
